import { memo, useEffect, useState } from 'react';

import { IcCancelFullScreenIcon, IcFullScreenIcon } from '@gem/icons';
import { IconButton, IconViewSizes } from '@gem/ui-kit';
import { enterFullScreen, exitFullScreen } from '@gem/utils';

interface IEntireScreenButtonProps {
  className?: string;
}
export const EntireScreenButton = memo<IEntireScreenButtonProps>((props) => {
  const [isFullScreen, setIsFullScreen] = useState(Boolean(document.fullscreenElement));

  const updateFullScreen = (): void => setIsFullScreen(Boolean(document.fullscreenElement));

  const onClick = async (): Promise<void> => {
    if (isFullScreen) {
      await exitFullScreen();
      setIsFullScreen(false);
      return;
    }

    await enterFullScreen();
    setIsFullScreen(true);
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', updateFullScreen);
    return (): void => {
      document.removeEventListener('fullscreenchange', updateFullScreen);
      if (isFullScreen) {
        exitFullScreen();
      }
    };
  }, [isFullScreen]);

  return (
    <IconButton
      dataTest="callview-call-additional-actions-panel-fullscreen-button"
      className={props.className}
      Icon={isFullScreen ? IcCancelFullScreenIcon : IcFullScreenIcon}
      onClick={onClick}
      size={IconViewSizes.Big}
      iconSize={IconViewSizes.Medium}
      theme="12"
    />
  );
});
